import { apiClient, unwrap } from './client';

import type { ApiResponse } from '@/types';

export interface QAItem {
  id: number;
  submission_id: number;
  evidence_id: string | null;
  question: string;
  answer: string;
  created_at: string;
}

export interface AskQuestionPayload {
  submission_id: number;
  question: string;
  evidence_id?: string | null;
}

export async function askQuestion(payload: AskQuestionPayload): Promise<QAItem> {
  const response = await apiClient.post<ApiResponse<QAItem>>('/qa/ask', payload);
  return unwrap(response);
}

export async function getQAHistory(submissionId: number): Promise<QAItem[]> {
  const response = await apiClient.get<ApiResponse<QAItem[]>>(`/qa/history/${submissionId}`);
  return unwrap(response);
}
